// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pheromosa: PokeData = {
  "id": 795,
  "name": "pheromosa",
  "height": 18,
  "weight": 250,
  "base_experience": 257,
  "types": [
    PokeType.BUG,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "stomp",
    "double-kick",
    "jump-kick",
    "leer",
    "low-kick",
    "agility",
    "swift",
    "high-jump-kick",
    "triple-kick",
    "rapid-spin",
    "silver-wind",
    "bounce",
    "feint",
    "me-first",
    "bug-buzz",
    "bug-bite",
    "quiver-dance",
    "quick-guard",
    "lunge",
    "speed-swap"
  ],
  "moves": [
    "double-kick",
    "jump-kick",
    "leer",
    "bug-buzz",
    "bug-bite",
    "lunge",
    "drain-punch",
    "sticky-web",
    "superpower",
    "coaching",
    "pounce",
    "bulk-up",
    "leech-steal"
  ],
  "evolution_chain": {
    "id": 416,
    "item": null,
    "species": [
      {
        "name": "pheromosa",
        "order": 795,
        "types": [
          PokeType.BUG,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 63,
    "speed": 177,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
